module.exports = __webpack_public_path__ + "img/sec5_1.e6421608.jpg";